import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-8 mt-16">
          <h1 className="text-3xl font-bold text-gray-900 mb-4 text-center">
            Privacy Policy
          </h1>
          <h2 className="text-xl font-semibold text-gray-700 mb-6 mt-8 text-left">
            Agreement & Terms and conditions of use
          </h2>
        </div>

        {/* Content */}
        <div className="space-y-8">
          
        <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          1. Agreement
        </h2>
        <p className="text-gray-700 leading-relaxed text-justify">
          These Agreement, terms and conditions and the privacy policy together constitute a legal binding agreement
          (Agreement) between (Cocopalms Tech Co) and you and we mean by (YOU) whether you are a client or a user
          of the platform.
        </p>
      </section>

      {/* Law and Jurisdiction Section */}
      <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          2. Law and jurisdiction
        </h2>
        
        <div className="space-y-4">
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">2.1</span>
            Your acceptance of these terms is considered to be an approved and signed electronic signature in our
            electronic system and confirms the validity of the agreement, by applying the provisions of Law No. 20/2014
            for electronic transactions, and all electronic data, information provided, offered, submitted, presented,
            shared, kept, used in or through the application are governed with the terms of the regulation 42/2021 in
            regards to privacy protection.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">2.2</span>
            This agreement and terms and conditions shall be governed by and construed in accordance with [Kuwaiti laws].
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">2.3</span>
            Any disputes relating to this agreement and/or terms and conditions shall be subject to the jurisdiction
            of the courts of (Kuwait).
          </p>
        </div>
      </section>

          {/* Cocopalms Section */}
      <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          3. Cocopalms
        </h2>
        
        <p className="text-gray-700 leading-relaxed text-justify">
          <span className="font-medium">3.1</span>
          Cocopalms Tech Company is a technology and Solution providing Company; Cocopalms focuses on automation 
          solutions, IT Solutions and Services. and deals with the Information and technology platform of Cocopalms 
          the next-generation Information Technology Services company who delivers innovative IT solutions & IT enabled 
          services precisely addressing the business needs of our clients. We provide business and technology consulting, 
          custom software development, web design & development, maintenance, systems integration, testing and business 
          process outsourcing etc. We have chosen a strategic global model combining the best of onshore and offshore 
          processes to deliver premium quality services and products to our clients. Focusing on the business needs of 
          our clients, Cocopalms technical expertise and domain knowledge has enabled Cocopalms to become a valued 
          business partner for a host of reputable customers across the globe.
        </p>
      </section>

      {/* License Section */}
      <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          4. License to use the platform
        </h2>
        
        <div className="space-y-4">
          <div>
            <p className="text-gray-700 leading-relaxed mb-2 text-justify">
              <span className="font-medium">4.1</span> You may:
            </p>
            <div className="ml-6 space-y-1">
              <p className="text-gray-700 text-justify">(a) View pages from the platform;</p>
              <p className="text-gray-700 text-justify">(b) Download pages from the platform for caching;</p>
              <p className="text-gray-700 text-justify">(c) Print pages from the platform;</p>
              <p className="text-gray-700 text-justify">(d) Use the platform services, subject to the other provisions of these terms and conditions.</p>
            </div>
          </div>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">4.2</span> Except as expressly permitted by the provisions of this agreement and terms and conditions, you must not 
            download any material from the platform or save any such material on the device.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">4.3</span> You may only use the platform for your own personal use, and you must not use the platform for any other purposes.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">4.4</span> Except as expressly permitted by these terms and conditions, you must not edit or otherwise modify any 
            material on the platform.
          </p>
          
          <div>
            <p className="text-gray-700 leading-relaxed mb-2 text-justify">
              <span className="font-medium">4.5</span> Unless you own or control the relevant rights in the material, you must not:
            </p>
            <div className="ml-6 space-y-1">
              <p className="text-gray-700 text-justify">(a) Republish material from the platform (including republication on another platform);</p>
              <p className="text-gray-700 text-justify">(b) Sell, rent or sub-license material from the platform;</p>
              <p className="text-gray-700 text-justify">(c) Show any material from the platform in public;</p>
              <p className="text-gray-700 text-justify">(d) Exploit material from the platform for a commercial purpose; or redrafting;</p>
              <p className="text-gray-700 text-justify">(e) Redistribute material from the platform.</p>
            </div>
          </div>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">4.6</span>  We reserve the right to restrict access to areas of the platform, or indeed the whole platform, at your 
            discretion; you must not circumvent or bypass, or attempt to circumvent or bypass, any access restriction 
            measures on the platform.
          </p>
        </div>
      </section>

           {/* Acceptable Use Section */}
      <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          5. Acceptable Use
        </h2>
        
        <div className="space-y-4">
          <div>
            <p className="text-gray-700 leading-relaxed mb-2 text-justify">
              <span className="font-medium">5.1</span> You must not:
            </p>
            <div className="ml-6 space-y-1">
              <p className="text-gray-700 text-justify">(a) Use the platform in any way or take any action that causes, or may cause, damage to the platform or impairment of the performance, availability or accessibility of the platform;</p>
              <p className="text-gray-700 text-justify">(b) Use the platform in any way that is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity;</p>
              <p className="text-gray-700 text-justify">(c) Use the platform to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, mobile or computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious mobile or computer software;</p>
              <p className="text-gray-700 text-justify">(d) Conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to the platform without the express written consent;</p>
              <p className="text-gray-700 text-justify">(e) Violate the directives set out in the robots.txt file for the platform; or</p>
              <p className="text-gray-700 text-justify">(f) Use of data collected from the app for any direct marketing activity (including but not limited to email marketing, SMS marketing, telemarketing, social media marketing and sponsor ads and direct mail).</p>
            </div>
          </div>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">5.2</span> You must not use data collected from the platform to contact individuals, companies or other persons or entities.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">5.3</span> You must ensure that all the information you supply to us through the platform, or in relation to the platform, is true, accurate, current, complete and non-misleading.
          </p>
        </div>
      </section>

      {/* Clients Section */}
      <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          6. Clients
        </h2>
        <p className="text-gray-700 leading-relaxed text-justify">
          All Cocopalms clients.
        </p>
      </section>
        
      {/* User IDs and passwords Section */}
      <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          7. User IDs and passwords
        </h2>
        
        <div className="space-y-4">
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">7.1</span> If you register for an account with the platform, you will be asked to enter your [name. e-mail, phone number, birthdate and a password].
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">7.2</span> Your information must not be liable to mislead and you must not use your information for or in connection with the impersonation of any person.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">7.3</span> You must keep your password confidential.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">7.4</span> You must notify the platform management in writing immediately if you become aware of any disclosure of your password.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">7.5</span> You are responsible for any activity on the platform arising out of any failure to keep your password confidential, and may be held liable for any losses arising out of such a failure.
          </p>
        </div>
      </section>

      {/* Cancellation and suspension Section */}
      <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          8. Cancellation and suspension of account
        </h2>
        
        <div className="space-y-4">
          <div>
            <p className="text-gray-700 leading-relaxed mb-2 text-justify">
              <span className="font-medium">8.1</span> We may:
            </p>
            <div className="ml-6 space-y-1">
              <p className="text-gray-700 text-justify">(a) Suspend your account;</p>
              <p className="text-gray-700 text-justify">(b) Cancel your account; and/or</p>
              <p className="text-gray-700 text-justify">(c) Edit your account details,</p>
            </div>
            <p className="text-gray-700 leading-relaxed mt-2 text-justify">
              At any time in our sole discretion without notice or explanation.
            </p>
          </div>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">8.2</span> You may cancel your account on the platform using your account control panel on the platform.
          </p>
        </div>
      </section>
 {/* Your content: rules Section */}
 <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          9. Your content: rules
        </h2>
        
        <div className="space-y-4">
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">9.1</span> You warrant and represent that your content will comply with this agreement and terms and conditions.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">9.2</span> Your content must not be illegal or unlawful, must not infringe any person's legal rights, and must not be capable of giving rise to legal action against any person (in each case in any jurisdiction and under any applicable law).
          </p>
          
          <div>
            <p className="text-gray-700 leading-relaxed mb-2 text-justify">
              <span className="font-medium">9.3</span> Your content, and the use of your content by us in accordance with this agreement and terms and conditions, must not:
            </p>
            <div className="ml-6 space-y-1">
              <p className="text-gray-700 text-justify">(a) Be libelous or maliciously false;</p>
              <p className="text-gray-700 text-justify">(b) Be obscene or indecent;</p>
              <p className="text-gray-700 text-justify">(c) Infringe any copyright, moral right, database right, trade mark right, design right, right in passing off, or other intellectual property right;</p>
              <p className="text-gray-700 text-justify">(d) Infringe any right of confidence, right of privacy or right under data protection legislation;</p>
              <p className="text-gray-700 text-justify">(e) Constitute negligent advice or contain any negligent statement;</p>
              <p className="text-gray-700 text-justify">(f) Constitute an incitement to commit a crime, instructions for the commission of a crime or the promotion of criminal activity;</p>
              <p className="text-gray-700 text-justify">(g) Be in contempt of any court, or in breach of any court order;</p>
              <p className="text-gray-700 text-justify">(h) Be in breach of racial or religious hatred or discrimination legislation;</p>
              <p className="text-gray-700 text-justify">(i) Be blasphemous;</p>
              <p className="text-gray-700 text-justify">(j) Be in breach of official legislation;</p>
              <p className="text-gray-700 text-justify">(k) Be in breach of any contractual obligation owed to any person;</p>
              <p className="text-gray-700 text-justify">(l) Depict violence in an explicit, graphic or gratuitous manner;</p>
              <p className="text-gray-700 text-justify">(m) Be pornographic, lewd, suggestive or sexually explicit;</p>
              <p className="text-gray-700 text-justify">(n) Be untrue, false, inaccurate or misleading;</p>
              <p className="text-gray-700 text-justify">(o) Consist of or contain any instructions, advice or other information which may be acted upon and could, if acted upon, cause illness, injury or death, or any other loss or damage;</p>
              <p className="text-gray-700 text-justify">(p) Constitute spam;</p>
              <p className="text-gray-700 text-justify">(q) Be offensive, deceptive, fraudulent, threatening, abusive, harassing, anti-social, menacing, hateful, discriminatory or inflammatory; or</p>
              <p className="text-gray-700 text-justify">(r) Cause annoyance, inconvenience or needless anxiety to any person.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Liability Section */}
      <section>
        <h2 className="text-base font-bold text-gray-800 mb-4">
          10. Liability
        </h2>
        
        <div className="space-y-4">
          <div>
            <p className="text-gray-700 leading-relaxed mb-2 text-justify">
              <span className="font-medium">10.1</span> Nothing in a contract in regard to this agreement and terms and conditions will:
            </p>
            <div className="ml-6 space-y-1">
              <p className="text-gray-700 text-justify">(a) Limit or exclude any liability for death or personal injury resulting from negligence;</p>
              <p className="text-gray-700 text-justify">(b) Limit or exclude any liability for fraud or fraudulent misrepresentation;</p>
              <p className="text-gray-700 text-justify">(c) Limit any liabilities in any way that is not permitted under applicable law; or</p>
              <p className="text-gray-700 text-justify">(d) Exclude any liabilities that may not be excluded under applicable law;</p>
              <p className="text-gray-700 text-justify">(e) Govern all liabilities arising in regards to this agreement and terms and conditions or relating to the subject matter of that contract, including liabilities arising in contract, in tort (including negligence) and for breach of statutory duty, except to the extent expressly provided otherwise in that contract.</p>
            </div>
          </div>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">10.2</span> To the extent that the platform and the information and services on the platform are provided free of charge, we will not be liable for any loss or damage of any nature.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">10.3</span> We will not be liable to you in respect of any losses arising out of any event or events beyond our reasonable control.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">10.4</span> We will not be liable to you in respect of any business losses, including (without limitation) loss of or damage to profits, income, revenue, use, production, anticipated savings, business, contracts, commercial opportunities or goodwill.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">10.5</span> We will not be liable to you in respect of any loss or corruption of any data, database or software.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">10.6</span> We will not be liable to you in respect of any special, indirect or consequential loss or damage.
          </p>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">10.7</span> You accept that we have an interest in limiting the personal liability of our officers and employees and, having regard to that interest, you acknowledge that we are a limited liability entity; you agree that you will not bring any claim personally against our officers or employees in respect of any losses you suffer in connection with the platform or this agreement and terms and conditions (this will not, of course, limit or exclude the liability of the limited liability entity itself for the acts and omissions of our officers and employees).
          </p>
        </div>
      </section>

         {/* Breaches Section */}
<section>
  <h2 className="text-base font-bold text-gray-800 mb-4">
    11. Breaches of this agreement and terms and conditions
  </h2>
  
  <div className="space-y-4">
    <div>
      <p className="text-gray-700 leading-relaxed mb-2">
        <span className="font-medium">11.1</span> Without prejudice to our other rights under this agreement and terms and conditions, if you breach this agreement and terms and conditions in any way, or if we reasonably suspect that you have breached this agreement and terms and conditions in any way, we may:
      </p>
      <div className="ml-6 space-y-1">
        <p className="text-gray-700">(a) Send you one or more formal warnings;</p>
        <p className="text-gray-700">(b) Temporarily suspend your access to the platform;</p>
        <p className="text-gray-700">(c) Permanently prohibit you from accessing the platform;</p>
        <p className="text-gray-700">(d) Block computers/mobile devices using your IP address from accessing the platform;</p>
        <p className="text-gray-700">(e) Contact any or all of your internet service providers and request that they block your access to the platform;</p>
        <p className="text-gray-700">(f) Commence legal action against you, whether for breach of this agreement and terms and conditions or otherwise; and/or</p>
        <p className="text-gray-700">(g) Suspend or delete your account on the platform.</p>
      </div>
    </div>
  </div>
</section>

{/* Variation Section */}
<section>
  <h2 className="text-base font-bold text-gray-800 mb-4">
    12. Variation
  </h2>
  
  <div className="space-y-4">
    <p className="text-gray-700 leading-relaxed text-justify">
      <span className="font-medium">12.1</span> We may revise and amend this agreement and terms and conditions from time to time.
    </p>
    
    <p className="text-gray-700 leading-relaxed text-justify">
      <span className="font-medium">12.2</span> The revised agreement and terms and conditions shall apply to the use of the platform from the date of publication of the revised agreement and terms and conditions on the platform, and you hereby waive any right you may otherwise have to be notified of, or to consent to, revisions of this agreement and terms and conditions. / We will give you written notice [by email, or any method that we decide] of any revision of this agreement and terms and conditions, and the revised agreement and terms and conditions will apply to the use of the platform from the date that we give you such notice; if you do not agree to the revised agreement and terms and conditions, you can contact the platform administration, or you can stop using the platform.
    </p>
    
    <p className="text-gray-700 leading-relaxed">
      <span className="font-medium">12.3</span> If you have given your express acceptance to this agreement and terms and conditions, we will ask for your express acceptance to any revision of this agreement and terms and conditions; and if you do not give your express acceptance to the revised agreement and terms and conditions within such period as we may specify, we will disable or delete your account on the platform, and you must stop using the platform.
    </p>
  </div>
</section>
          {/* Severability Section */}
        <section>
          <h2 className="text-base font-bold text-gray-800 mb-4">
            13. Severability
          </h2>
          
          <div className="space-y-4">
            <p className="text-gray-700 leading-relaxed text-justify">
              <span className="font-medium">13.1</span> If a provision of this agreement and terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect.
            </p>
            
            <p className="text-gray-700 leading-relaxed text-justify">
              <span className="font-medium">13.2</span> If any unlawful and/or unenforceable provision of this agreement and terms and conditions would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.
            </p>
          </div>
        </section>

        {/* Third party rights Section */}
        <section>
          <h2 className="text-base font-bold text-gray-800 mb-4">
            14. Third party rights
          </h2>
          
          <div className="space-y-4">
            <p className="text-gray-700 leading-relaxed text-justify">
              <span className="font-medium">14.1</span> This agreement and terms and conditions is for our benefit and your benefit, and is not intended to benefit or be enforceable by any third party.
            </p>
            
            <p className="text-gray-700 leading-relaxed text-justify">
              <span className="font-medium">14.2</span> The exercise of the parties' rights under this agreement and terms and conditions is not subject to the consent of any third party.
            </p>
          </div>
        </section>

        {/* Entire agreement Section */}
        <section>
          <h2 className="text-base font-bold text-gray-800 mb-4">
            15. Entire agreement
          </h2>
          
          <p className="text-gray-700 leading-relaxed text-justify">
            <span className="font-medium">15.1</span> This agreement and terms and conditions, together with the privacy policy, shall constitute the entire agreement between you [User, Client,] and Cocopalms in relation to your use of the platform and shall supersede all previous agreements between you and Cocopalms in relation to your use of the platform.
          </p>
        </section>

        {/* Cocopalms details Section */}
        <section>
          <h2 className="text-base font-bold text-gray-800 mb-4">
            16. Cocopalms details
          </h2>
          
          <div className="space-y-4">
            <p className="text-gray-700 leading-relaxed text-justify">
              <span className="font-medium">16.1</span> This platform is owned and operated by [Cocopalms Tech Co. W.L.L].
            </p>
            
            <p className="text-gray-700 leading-relaxed text-justify">
              <span className="font-medium">16.2</span> We are registered in [Kuwait] under registration number 144989/2019, and our registered office is at Kuwait.
            </p>
            
            <p className="text-gray-700 leading-relaxed text-justify">
              <span className="font-medium">16.3</span> Our principal place of business is at Kuwait.
            </p>
            
            <p className="text-gray-700 leading-relaxed text-justify">
              <span className="font-medium">16.4</span> You can contact us by writing to the business address given above, by using the platform contact form, by email to <span className="font-bold">info@cocopalms.io</span> or by telephone on <span className="font-bold">+965 9918 5891</span>.
            </p>
          </div>
        </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;  